import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const FloatingActionButton = ({ onClick, className }) => {
    return (
        <Button
            onClick={onClick}
            size="lg"
            className={cn(
                "fixed bottom-24 right-6 w-14 h-14 rounded-full shadow-lg z-50",
                "bg-primary hover:bg-primary/90 text-white font-semibold",
                className
            )}
        >
            <Plus className="w-6 h-6 text-white" />
        </Button>
    );
};

export default FloatingActionButton;
